/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance } from 'mobx-state-tree';
import { PeriodModel } from './period.model';
const { model, string, number, identifierNumber, boolean } = types;

export const CurrentPlanModel = model('CurrentPlanModel', {
  id: identifierNumber,
  name: string,
  quantity: number,
  addOn: boolean,
  isTrial: boolean,
  status: number,
  period: PeriodModel,
});

export type ICurrentPlanModel = Instance<typeof CurrentPlanModel>;
